<template>
<div class="allBox">
   <my-header></my-header>
   <div class="pageSet">
      <div class="claLeft">
        <p class="marBot10"><img src="../../../../static/img/404.png" width="79"></p>
        <h3>抱歉，您访问的页面不存在...</h3>
        <p>可能原因：</p>
        <p>• 网络不稳定</p>
        <p>• 尚未接入互联网</p>
        <p>• 安全软件禁止访问网络</p>
        <p><a class="btn2" href="/">返回首页</a></p>
           
      </div>
      <div class="claRight"><img src="../../../../static/img/404_imgbg.png" width="284"></div>
      <div class="cl"></div>
  </div>
  <regBottom></regBottom>
</div>
  
</template>
<script>
import regBottom from '@/components/Reception/reg/regBottom.vue'
export default {
  components: {regBottom },
  data() {
    return {
     
    };
  },
  created() {
   
  },
  computed: {},
  methods: {
   back(){
        this.$router.go(-1);//返回上一层
    },
  },
};
</script>
<style scoped>
.allBox{background:#fff;width:100%;height:100%;margin: 0px}
.pageSet{width:1200px;margin:100px auto 0;}
.pageSet .claLeft{
  float: left;width:350px;margin-left:250px;
}
.pageSet .claLeft h3{font-size:22px;line-height:40px;}
.pageSet .claLeft p{line-height:30px;font-size:14px;color: black;}
.pageSet .claRight{float: left;width:600px;}


.btn2{background:#0C5ee4;color:#fff;font-size:16px;border-radius:100px;width:120px;height:35px;line-height:35px;
display:inline-block;margin-top:15px;text-align: center}

</style>



// WEBPACK FOOTER //
// src/components/Reception/404/404.vue